import { useEffect, useState } from "react";

interface UseViewportOptions {
  mobileBreakpoint?: number;
  tabletBreakpoint?: number;
}

export const useViewport = (options: UseViewportOptions = {}) => {
  const { mobileBreakpoint = 800, tabletBreakpoint = 1024 } = options;

  const getWidth = () =>
    typeof window !== "undefined" ? window.innerWidth : 0;

  const [viewportWidth, setViewportWidth] = useState(getWidth);

  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobileView = viewportWidth <= mobileBreakpoint;
  const isTabletView =
    viewportWidth > mobileBreakpoint && viewportWidth <= tabletBreakpoint;

  return {
    viewportWidth,
    isMobileView,
    isTabletView,
  };
};
